import type { Pagination } from '@aigc/types';
import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { HistoryDto } from '../common/model';
import type { ScriptListInputDto } from './model';
import type {
  PatchScriptDto,
  SaveScriptDto,
  ScriptListItemDto,
} from './script.dto';

export const saveScript = async (data: SaveScriptDto) => {
  await http
    .post('script/save', {
      json: data,
    })
    .json<void>();
};

export const patchScript = async (script_id: string, data: PatchScriptDto) => {
  await http
    .patch(`scripts/${script_id}`, {
      json: data,
    })
    .json<{ id: string }>();
};

export const queryManyScripts = async (
  pagination: Pagination,
  query?: ScriptListInputDto,
) => {
  return http
    .post('script/history', {
      json: {
        pagination,
        ...query,
      },
    })
    .json<HistoryDto<ScriptListItemDto>>();
};

export const getScriptsQueryOptions = (
  admin: boolean,
  pagination: Pagination,
  input?: ScriptListInputDto,
) =>
  queryOptions({
    queryKey: ['脚本列表', admin, pagination, input],
    queryFn: async () => {
      const url = admin ? 'statistics/script/history' : 'script/history';

      const result = await http
        .post(url, {
          json: {
            pagination,
            ...input,
          },
        })
        .json<HistoryDto<ScriptListItemDto>>();
      return result;
    },
  });

export const createScriptMutation = mutationOptions({
  mutationKey: ['脚本列表'],
  mutationFn: async (data: SaveScriptDto) => {
    await saveScript(data);
  },
});

export const updateScriptMutation = mutationOptions({
  mutationKey: ['脚本列表'],
  mutationFn: async ({
    script_id,
    ...data
  }: PatchScriptDto & { script_id: string }) => {
    await patchScript(script_id, data);
  },
});

export const getOneScriptQueryOptions = (id: string) => {
  return queryOptions({
    queryKey: ['脚本', id],
    queryFn: async () => {
      const result = await http
        .post('script/get', {
          json: {
            id,
          },
        })
        .json<ScriptListItemDto>();

      return result;
    },
  });
};
